import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { Mark, SectionTitle } from './ui/Section';
export function Testimonials() {
  return <section className="bg-slate-50 px-4 py-12 md:py-16" data-id="element-250" data-mp="3fze45yusr5w7">
      <div className="mx-auto max-w-6xl" data-id="element-251" data-mp="3fxuooagysyvh">
        <SectionTitle data-id="element-252" data-mp="3b147fjtfbx8h">
          Professional <Mark data-id="element-253" data-mp="3azt05a0rs7cm">feedback</Mark>
        </SectionTitle>

        <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-6" data-id="element-254" data-mp="36yppr31hr3is">
          {testimonials.map((item, index) => <figure key={item.name} className={`flex flex-col rounded-2xl border border-teal-800/10 bg-white p-6 shadow-sm lg:col-span-2 ${index === 3 ? 'lg:col-start-2' : ''}`} data-id="element-255" data-mp="31zmrc1g0nvjs" data-mpi={index}>
              <div className="flex gap-0.5" role="img" aria-label="5 out of 5 stars" data-id="element-256" data-mp="2s306vdrlr6ia">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-257" data-mp="qac0ivjnw2ya" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-teal-950" data-id="element-258" data-mp="h559bys2ppvi">“{item.quote}”</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-teal-800/10 pt-4" data-id="element-259" data-mp="m6m55fvpam58">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-teal-800 text-xs font-black text-white" data-id="element-260" data-mp="79lfrj0zf39x">
                  {item.initials}
                </span>
                <span data-id="element-261" data-mp="zx7t3j00hm9z">
                  <span className="block text-sm font-extrabold uppercase text-teal-950" data-id="element-262" data-mp="zyseai0frsv6">{item.name}</span>
                  <span className="block text-xs text-slate-600" data-id="element-263" data-mp="q6mkr3ujd3dv">{item.role}</span>
                </span>
              </figcaption>
            </figure>)}
        </div>
        <p className="mt-6 text-center text-xs text-slate-600" data-id="element-264" data-mp="v3mt5leuyi85">Individual experiences may vary.</p>
      </div>
    </section>;
}